import { css } from 'styled-components';

const Required = () => (
  <span title={I18n.t('views.backoffice.required')}> *</span>
);

export const AbbrRequired = () => (
  <abbr
    title={I18n.t('views.backoffice.required')}
    // eslint-disable-next-line react/no-unknown-property
    css={css`
      margin-left: 5px;
    `}
  >
    *
  </abbr>
);

export default Required;
